import React, { useState, useEffect } from "react";
import Table from "../../../Common/Table";
import KeyValTable from "../Common/KeyValTable";

const Disputes = ({ data = {} }) => {
  function getItems() {
    return data.basic || [];
  }
  return (
    <div>
      <h2>Basic</h2>
      <KeyValTable data={getItems()} />
    </div>
  );
};

export default Disputes;
